import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { resetPassword } from "../../../redux/slices/authSlice";
import { Link } from "react-router-dom";

import { Container, FormContainer, ImgSection } from "./ResetPasswordStyles";
import Logo from "../../../components/common/Brand";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //const { userId } = useParams();
  const { loading, validateResetCode } = useSelector((state) => state.auth);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const userId = validateResetCode?.code
  const toggleType = () => {
    setShowPassword(!showPassword);
  };
  const toggleType2 = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const [formData, setFormData] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(resetPassword({ userId, ...formData }));
    if (resetPassword.fulfilled.match(result)) {
      navigate("/login");
    }
  };

  return (
    <Container>
      <FormContainer>
        <Link to="/">
          <Logo size={38} />
        </Link>
        <h1>Reset Password</h1>
        <form onSubmit={handleSubmit}>
          <div className="single-form">
            <label htmlFor="new-password">Enter new password</label>
            <input
              type={showPassword ? "text" : "password"}
              name="newPassword"
              placeholder="Enter new password"
              required
              value={formData.newPassword}
              onChange={handleChange}
            />
            {showPassword ? (
              <FaEyeSlash className="eye" onClick={toggleType} />
            ) : (
              <FaEye className="eye" onClick={toggleType} />
            )}
          </div>

          <div className="single-form">
            <label htmlFor="confirm-password">Confirm password</label>
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmNewPassword"
              placeholder="Confirm password"
              required
              value={formData.confirmNewPassword}
              onChange={handleChange}
            />
            {showConfirmPassword ? (
              <FaEyeSlash className="eye" onClick={toggleType2} />
            ) : (
              <FaEye className="eye" onClick={toggleType2} />
            )}
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </FormContainer>

      <ImgSection>
        <div>
          <Logo size={30} tone="light" />
          <p>
            Run your ads and campaigns with ClickCircle and make huge <br />
            impressions and conversions that will help your business{" "}
          </p>
        </div>
      </ImgSection>
    </Container>
  );
};

export default ResetPassword;
